import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';
import { mapToBillingTransactionFilter } from './util';

export const SYNC_BILLS = gql`
  mutation syncBills($input: SyncBillsInput!) {
    syncBills2(syncBillsInput: $input) {
      completed
      failed
      total
    }
  }
`;

export const useSyncBills = ({
  excludedBillIds,
  isAllSelected,
  filter,
  setIsSyncing
}) => {
  const [syncBills] = useMutation(SYNC_BILLS);

  return {
    syncBills: async billsToSync => {
      setIsSyncing(true);
      const { data } = await syncBills({
        variables: {
          input: {
            includeBillIds: billsToSync,
            excludeBillIds: excludedBillIds,
            allSelected: isAllSelected,
            filter: mapToBillingTransactionFilter({
              filter
            })
          }
        },
        refetchQueries: ['getPageOfBillingTransactions'],
        awaitRefetchQueries: true
      });

      setIsSyncing(false);

      return get(data, 'syncBills2', null);
    }
  };
};
export default useSyncBills;
